export default () => (
  <div className="container full-height">
    <div style={{textAlign: 'center'}}>
      <p>Privacy policy</p>
    </div>
  </div>
)
